<template>
  <div class="main-layout yx-student-predicted-page">
    <el-card class="box-inner">
      <c-title slot="header" title="预报到" :back="false"></c-title>
      <div class="div-scroll">
        <div class="tips-container">
          <div class="tips">
            <div class="title">
              <i class="el-icon-info"></i><span>温馨提示</span>
            </div>
            <p>1.请在预报到周期内完成以下工作;</p>
            <p>2.请确保填写信息真实有效。</p>
          </div>
        </div>
        <div class="predicted-list" v-if="!isPay">
          <div
            class="pre-item"
            v-for="(item, index) in predictedList"
            :key="item.id"
            @click="goto(item)"
          >
            <img
              :src="
                require('../../../../assets/images/prediect/status_' +
                  item.doneStatus +
                  '.png')
              "
              class="status-img"
            />
            <div class="item-index">
              <img
                :src="
                  require('../../../../assets/images/prediect/' +
                    (index + 1) +
                    '.png')
                "
                alt=""
                class="index-img"
                :class="{ first: index == 0 }"
              />
              <img
                :src="
                  require('../../../../assets/images/prediect/' +
                    item.icon +
                    '.png')
                "
                alt=""
                class="icon"
              />
            </div>
            <div class="item-left">
              <p class="title ellipsis">{{ item.name }}</p>
              <p class="ellipsis">{{ item.brief }}</p>
              <p class="ellipsis">
                <span
                  >状态：<span
                    :class="{
                      grey: item.status == 0,
                      green: item.status == 1,
                      red: item.status == 2,
                    }"
                    >{{
                      item.status == 0
                        ? "未开始"
                        : item.status == 1
                        ? "进行中"
                        : "已结束"
                    }}</span
                  ></span
                >
              </p>
              <p class="ellipsis">
                距离结束时间：<span class="red">{{
                  item.lastTime || "--"
                }}</span>
              </p>
            </div>
            <div class="item-right">
              <!-- 0未完成 1已完成 2驳回 3审核通过 4审核中 -->
              <el-button
                type="primary"
                v-if="item.status == 1 && item.doneStatus == 0"
                size="small"
                >去办理</el-button
              >
              <el-button
                type="primary"
                v-else-if="item.status == 1 && item.doneStatus == 1"
                size="small"
                >修改</el-button
              >
              <el-button
                type="primary"
                v-else-if="item.status == 1 && item.doneStatus == 2"
                size="small"
                >编辑</el-button
              >
            </div>
          </div>
        </div>
        <div v-else class="empty">
          <img src="../../../../assets/images/pay_icon.png" alt="" />
          <p>您已完成缴费，不可修改预报到事项！</p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
      predictedList: [],
      isPay: false,
      isNeedExchange: false, // 是否必须换专业
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.getPredictedList();
  },
  mounted() {},
  methods: {
    goto(data) {
      // 0未完成 1已完成 2驳回 3审核中 4审核通过  5已拒绝
      // 0,1,2可跳转编辑
      console.log(data);
      if (data.status == 0) {
        return this.$message.warning(`该事项暂未开始`);
      } 
      // else if (data.status == 2) {
      //   return this.$message.warning(`该事项已结束`);
      // } 
      else {
        this.pushRoute(data);
      }
    },
    // 跳转路由
    pushRoute(data) {
      if (data.url) {
        this.checkTestIsComplete(data);
      }
    },
    // 校验是否通过了入学测试
    checkTestIsComplete(data) {
      this.$http.get("/welcome-forecast/test/isPass").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          let params = `/${data.id}/${data.status}/${data.isOrNot}`;
          this.$router.push(data.url + params);
        } else {
          this.$message.warning("请先通过入学测试");
        }
      });
    },
    getPredictedList() {
      this.$http
        .get("/welcome-forecast/student/forecast/myInfo")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            if (res.data) {
              let data = res.data;
              data.forEach((item) => {
                if (item.status == 1) {
                  let t1 = new Date().getTime();
                  let t2 = new Date(item.endTime).getTime();
                  //计算时间差并转换成标准时间单位
                  let dura = t2 - t1;
                  item.lastTime = this.formatDuring(dura);
                } else {
                  item.lastTime = null;
                }
              });
              this.predictedList = data;
            }
          } else {
            this.$message.error(`${res.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`${err}`);
        });
    },
    // 校验是否必须转专业
    isNeedExchangeMajor() {
      this.$http
        .get("/welcome/exchange/rule/isNeedExchangeMajor")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // 如果data为true则是必须调整专业，如为false则非必须
            this.isNeedExchange = res.data;
          } else {
            this.isNeedExchange = false;
          }
        })
        .catch((err) => {
          this.isNeedExchange = false;
        });
    },
    formatDuring(mss) {
      let times = mss / 1000;
      var d = parseInt(times / 60 / 60 / 24); // 天
      var h = parseInt((times / 60 / 60) % 24); //时
      var m = parseInt((times / 60) % 60); // 分
      return d + " 天 " + h + " 小时 " + m + "分";
    },
  },
};
</script>
<style lang="less" scoped>
.tips-container {
  padding-top: 20px;
  padding-left: 30px;
  .tips {
    margin-bottom: 15px;
    color: #787878;

    i.el-icon-info {
      vertical-align: middle;
      font-size: 18px;
      margin-right: 5px;
      color: #409eff;
    }

    .title {
      font-size: 16px;
      line-height: 30px;
      // padding-left: 25px;
      color: #5a5a5a;
    }

    p {
      text-indent: 2em;
      line-height: 26px;
    }
  }
}
</style>
